import * as React from "react";
import { Form, Row, Col } from "antd";
import { FormComponentProps } from "antd/lib/form";
import "./trade-rejected.scss";
import { IVendaProps } from "src/services/interfaces/IVendaProps";
import { contato } from 'src/util/constants';

function TradeRejected(props: FormComponentProps & IVendaProps) {
  return (
    <div className="documents steps-container" style={{ width: "90%" }}>
      <div className="steps-container-description">
        <Row>
          <Col xs={24} sm={24} md={6} lg={6}>
            <div className="rejected-lock" />
          </Col>
          <Col xs={0} sm={0} md={1} lg={1} />
          <Col xs={24} sm={24} md={17} lg={17}>
            <p>Sua documentação passou por uma detalhada análise interna e, infelizmente, não foi possível prosseguir com a negociação.</p>
            <p style={{ fontSize: "28px", fontWeight: "bold" }}>Por favor, entre em contato via:</p>
            <p style={{ fontSize: "22px", fontWeight: "bold" }}>
              <span style={{ color: "white", backgroundColor: "#4d8bff", padding: "15px 20px", borderRadius: "30px", marginRight: "10px" }}>{contato.whatsappFormatado}</span> ou
              <br />
              <span style={{ color: "white", backgroundColor: "#4d8bff", padding: "15px 20px", borderRadius: "30px", marginLeft: "10px" }}>contato@precatoriosbrasil.com</span>
            </p>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Form.create()(TradeRejected);



// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/trade-rejected/TradeRejected.tsx